import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAccountTransactions as getAccountTransactionsApi,
  createAccountTransaction as createAccountTransactionApi,
} from '../../helpers/bff_helper';

const namespace = 'account-transaction';

export const getAccountTransactions = createAsyncThunk(
  `${namespace}/getAccountTransactions`,
  async (params) => {
    params.order = 'desc';
    params.page = params.page || 1;
    try {
      const response = getAccountTransactionsApi(params);

      return response;
    } catch (error) {
      return error;
    }
  }
);

export const createAccountTransaction = createAsyncThunk(
  `${namespace}/createAccountTransaction`,
  async (data) => {
    try {
      const response = await createAccountTransactionApi(data);

      return response;
    } catch (error) {
      return {
        error: true,
        message: error,
      };
    }
  }
);

